const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

export async function fetchStandardRatios(companyId, periodId, basis = 'IFRS') {
  const params = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId),
    basis: String(basis || 'IFRS')
  });
  const response = await fetch(`${API_BASE}/api/analysis/ratios-standard?${params.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Sirket rasyolari alinamadi.');
}

const analysisRatiosStandardService = {
  fetchStandardRatios
};

export default analysisRatiosStandardService;
